// extracted by mini-css-extract-plugin
export default {"formDiv":"login_formDiv__9OL0y"};